#import "./SegmentDetails.graphql"
#import "./SentenceDetails.graphql"
fragment segmentedSentenceDetails on SegmentedSentenceType {
  id
  sentence {
    ...sentenceDetails
  }
  segments {
    ...segmentDetails
  }
}
